declare module 'axios' {
    export interface AxiosRequestConfig {
        /**
         * Disables global error notification.
         * Pass integer error codes to disable notification for specified status codes.
         * Example: [401] disables error notification for Unauthorized response.
         * A function can also be passed. It receives the error as a parameter and returns
         *  a boolean value indicating whether the error notification should be suppressed or not.
         */
        suppressShowError?: boolean | number[] | ((error: AxiosError) => boolean);
        hideGlobalLoader?: boolean;
    }
}

export type { AxiosRequestConfig } from 'axios';

export * from './ajax-handlers';
export * from './ajax-handlers-common';
export * from './ajax-handlers-csrf-token';
export * from './ajax-handlers-login-required';
export * from './ajax-handlers-parse-dates';
export * from './common';
export * from './loader';
export * from './with-microservice';
